import {} from "../node/index.js";
import {} from "./Net.js";
export function createNodeFromNodeEntry(nodeEntry) {
    return {
        "@type": "Value",
        "@kind": "Node",
        id: nodeEntry.id,
        name: nodeEntry.name,
        modId: nodeEntry.modId,
    };
}
//# sourceMappingURL=createNodeFromNodeEntry.js.map